export default "__VITE_ASSET__pHVcgosY__"